
const PATH = '/assets/langs/';
const LANGUAGES = [{ code: 'en' }];
const DEFAULT_LANGUAGE = 'en';
const SUPPORTED_LANGUAGES = LANGUAGES.map((l) => l.code);

export default class Translator {
  constructor() {

    this.isReady = false;
    this.lang = 'en';//this.getLanguage();
    this.dictionary = null;
  }

  async load() {
    const path = `${window.location.origin +(window.location.pathname === "/" ? "" : window.location.pathname)}/assets/langs/`;

    const response = await fetch(`${path}${this.lang}.json`);
    this.dictionary = await response.json();
    if (this.dictionary) {
      this.translate();
    } else {

    }
    this.isReady = true;
  }

  translate() {
    //console.log(this.dictionary);
    for (const key in this.dictionary.static) {
      let el = document.getElementById(key);
      if( el ){
        el.innerHTML = this.dictionary.static[key];
        //console.log("set ", key);
      }
    }

  }

  getDynamicText(id){
    if(this.isReady){
      if( this.dictionary.dynamic.hasOwnProperty(id)){
        return this.dictionary.dynamic[id];
      }else{
        return "";
      }
    }else{
      console.log("translator not ready");
      return "";
    }
  }

  getNumberAsWord(num,lang="en"){
    let number_words = ["","one","two","three","four","five","six","seven","eight","nine","ten"];
    return number_words[num];
  }
};
